{
  "theme.switch": "切换主题",
  "theme.light": "浅色",
  "theme.dark": "深色",
  "theme.system": "跟随系统",
  "user.role.admin": "管理员",
  "user.role.viewer": "只读",
  "user.role.scopeAll": "全域可见",
  "user.supportAgent": "客服人员",
  "user.openMenu": "打开用户菜单",
  "user.profile": "个人资料",
  "user.accountSettings": "账户设置",
  "user.signingOut": "正在退出…",
  "user.signOut": "退出登录",
  "user.signOutFailed": "退出登录失败，请重试。",
  "version.ready": "新版本已就绪",
  "version.description": "系统已更新，请刷新页面防止功能异常。",
  "version.refresh": "立即刷新",
  "auth.reload": "重新加载",
  "auth.relogin": "重新登录",
  "auth.callback.title": "正在完成登录",
  "auth.callback.detail": "身份验证已完成，正在进入 Tickbird。",
  "auth.restore.title": "正在恢复会话",
  "auth.restore.detail": "正在安全地连接身份服务，请稍候。",
  "auth.redirect.title": "正在跳转登录",
  "auth.redirect.detail": "即将前往组织身份服务完成登录。",
  "auth.error.title": "登录没有完成",
  "auth.error.detail": "请检查 IAM 客户端、回调地址和浏览器网络后重试。",
  "auth.firstStart": "首次启动",
  "auth.missingConfig.title": "还需要配置 IAM",
  "auth.missingConfig.copy": "将",
  "auth.missingConfig.as": "复制为",
  "auth.missingConfig.finish": "，填写 OIDC Authority 和 Client ID 后重启开发服务。SPA 客户端只使用 Authorization Code + PKCE，不配置客户端密钥。",
  "auth.session.loadingTitle": "正在准备工作台",
  "auth.session.loadingDetail": "正在读取你的账号与权限。",
  "auth.sessionExpired.title": "会话已过期",
  "auth.sessionExpired.detail": "重新登录后才能继续加载或提交数据。你可以暂时留在当前页面，请在重新登录前复制保存尚未提交的内容。",
  "auth.sessionExpired.reminder": "重新登录后可继续操作。离开当前页面前，请复制保存尚未提交的内容。",
  "auth.sessionExpired.dismiss": "暂不登录",
  "auth.sessionExpired.signIn": "重新登录",
  "auth.sessionExpired.signingIn": "正在跳转登录…",
  "auth.sessionExpired.failed": "暂时无法发起登录，请检查网络后重试。",
  "auth.admission.notProvisioned.title": "账号还未开通",
  "auth.admission.notProvisioned.detail": "你的身份已通过认证，但还没有被加入 tickbird。请联系管理员在「客服组和成员」页开通账号并分配角色，开通后重新加载即可。",
  "auth.admission.noRoles.title": "还没有分配角色",
  "auth.admission.noRoles.detail": "你的账号已开通，但还没有加入任何客服组、也没有全局角色，因此暂时没有任何可用功能。请联系管理员在「客服组和成员」页把你加进组并选择角色。",
  "auth.admission.inactive.title": "账号已停用",
  "auth.admission.inactive.detail": "你的 tickbird 账号已被停用。如果这不符合预期，请联系管理员。",
  "auth.admission.subjectMissing.title": "令牌不适用于工作台",
  "auth.admission.subjectMissing.detail": "当前令牌不包含人员身份（例如机器客户端令牌）。请用你的员工账号登录。",
  "auth.admission.failed.title": "没能读取会话",
  "auth.admission.failed.detail": "请检查网络后重试；若持续失败，请联系管理员查看服务状态。",
  "auth.permissionDenied.title": "无访问权限",
  "auth.permissionDenied.detail": "你没有访问该页面的权限。如果这不符合预期，请联系管理员调整你的角色。",
  "route.loading": "页面加载中…",
  "route.error.title": "页面遇到问题",
  "route.error.statusDescription": "页面请求失败（{status}）。",
  "route.error.description": "无法显示这个页面，请重新加载后再试。",
  "route.error.reload": "重新加载",
  "request.forbidden.title": "无访问权限",
  "request.forbidden.description": "你没有访问该内容的权限，请联系管理员开通。",
  "request.notFound.title": "内容不存在",
  "request.failed.title": "加载失败",
  "request.failed.description": "请求失败，请稍后重试。",
  "request.loading": "加载中…",
  "request.retry": "重试",
  "request.empty": "暂无数据",
  "loading.alt": "加载中",
  "select.loading": "加载中",
  "dataTable.empty": "暂无数据",
  "dataTable.filter.loading": "正在加载{label}",
  "dataTable.filter.searching": "正在搜索{label}",
  "dataTable.filter.clearLabel": "清除{label}筛选",
  "dataTable.filter.selected": "已选 {count} 项",
  "dataTable.filter.search": "搜索{label}…",
  "dataTable.filter.noMatches": "没有匹配项",
  "dataTable.filter.clear": "清除筛选",
  "dataTable.sort.trigger": "排序",
  "dataTable.sort.title": "排序规则",
  "dataTable.sort.description": "从上到下依次应用，最多可添加 {count} 个字段。",
  "dataTable.sort.ascending": "升序",
  "dataTable.sort.descending": "降序",
  "dataTable.sort.remove": "删除第 {index} 条排序规则",
  "dataTable.sort.empty": "尚未设置排序规则",
  "dataTable.sort.add": "添加排序",
  "dataTable.sort.clear": "清除",
  "dataTable.pagination.records": "条记录",
  "dataTable.pagination.label": "分页",
  "dataTable.pagination.total": "共 {count} {itemLabel}",
  "dataTable.pagination.previous": "上一页",
  "dataTable.pagination.next": "下一页",
  "dataTable.pagination.page": "第 {page} 页",
  "categorySelect.none": "未分类",
  "categorySelect.label": "分类",
  "categorySelect.searchLabel": "搜索分类",
  "categorySelect.searchPlaceholder": "搜索分类…",
  "categorySelect.treeLabel": "分类树",
  "categorySelect.expand": "展开 {name}",
  "categorySelect.collapse": "收起 {name}",
  "categorySelect.noMatches": "没有匹配的分类",
  "extendedInfo.value": "值",
  "extendedInfo.raw": "原始内容",
  "extendedInfo.booleanTrue": "是",
  "extendedInfo.booleanFalse": "否",
  "extendedInfo.showAll": "显示全部 {count} 项",
  "extendedInfo.showLess": "收起",
  "dataTable.scrollRegion": "表格内容",
  "dataTable.pagination.rowsPerPage": "每页条数"
}
